module.exports = __webpack_public_path__ + "media/promotional/hot-air-balloon-04395dc1.jpeg";